// lib/errorReporter.ts
import LogRocket from 'logrocket';
class ErrorReporter {
    constructor() {
        this.initialized = false;
    }
    // 单例模式
    static getInstance() {
        if (!ErrorReporter.instance) {
            ErrorReporter.instance = new ErrorReporter();
        }
        return ErrorReporter.instance;
    }
    // 初始化配置（只需在应用入口调用一次）
    init(config) {
        if (this.initialized)
            return;
        LogRocket.init(config.appId, {
            network: {
                requestSanitizer: (request) => {
                    const sanitizedRequest = Object.assign({}, request);
                    // 过滤userSession
                    if (request.headers.userSession) {
                        sanitizedRequest.headers.userSession = '';
                    }
                    // 过滤accessToken
                    if (request.headers.accessToken) {
                        sanitizedRequest.headers.accessToken = '';
                    }
                    return sanitizedRequest;
                },
                responseSanitizer: (response) => {
                    var _a;
                    const sanitizedResponse = Object.assign({}, response);
                    // 过滤掉用户信息
                    if (sanitizedResponse &&
                        ((_a = sanitizedResponse.url) === null || _a === void 0 ? void 0 : _a.indexOf('/member/loginByPassword')) !== -1) {
                        return Object.assign(Object.assign({}, sanitizedResponse), { body: null });
                    }
                    return sanitizedResponse;
                }
            },
            dom: {
                privateClassNameBlocklist: ['sensitive']
            }
        });
        this.initialized = true;
    }
    // 通用错误捕获方法
    captureException(error, context) {
        if (!this.initialized)
            return;
        LogRocket.captureException(error, {
            extra: Object.assign(Object.assign({}, context), { runtime: typeof window !== 'undefined' ? 'browser' : 'server' })
        });
    }
    captureMessage(message, context) {
        console.log('this.initialized', this.initialized);
        if (!this.initialized)
            return;
        LogRocket.captureMessage(message, {
            extra: Object.assign(Object.assign({}, context), { runtime: typeof window !== 'undefined' ? 'browser' : 'server' })
        });
    }
}
export const errorReporter = ErrorReporter.getInstance();
